<script setup>
// import {inject} from "vue";

const emit = defineEmits(['addStartup', 'inviteStartup']);

// const numbers = inject('numbers');
</script>

<template>
    <aside class="mystartups-page__aside">
        <div class="dashboard-page__card">
            <div class="dashboard-page__card__inner pb-4">
                <h3 class="dashboard-page__title">Add Startups</h3>

                <p>Add your portfolio startups in order to recommend them to enteprise companies</p>

                <button class="button button-primary button--lg w-100" @click="emit('addStartup')">Add Startups</button>
            </div>
        </div>

<!--        <div v-if="numbers.accounts" class="dashboard-page__card">-->
<!--            <div class="dashboard-page__card__inner pb-4">-->
<!--                <h3 class="dashboard-page__title">Invite startups</h3>-->

<!--                <p>{{numbers.accounts}} out of your {{numbers.total}} startups have claimed their profiles on SwitchPitch</p>-->

<!--                <button class="button button-bordered button&#45;&#45;lg w-100" @click="emit('inviteStartup')">Invite Startup</button>-->
<!--            </div>-->
<!--        </div>-->
    </aside>
</template>

<style scoped>

</style>
